<div class="mx-48 my-48 text-center">
  <p class="mt-4 text-3xl font-bold tracking-tight text-ica-primary sm:text-[8rem]">404</p>
  <p class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">
    Lo sentimos, no pudimos encontrar la página
  </p>
</div>
